const initialState = {
  invoiceSendData: {},
};

const SET_INVOICE_SEND_DATA = 'SET_INVOICE_SEND_DATA';
const SET_PROCESSOR_TYPE = 'SET_PROCESSOR_TYPE';

export const setInvoiceSendData = (payload) => ({
  type: SET_INVOICE_SEND_DATA,
  payload
});

export const setProcessorType = (payload) => ({
  type: SET_PROCESSOR_TYPE,
  payload,
});

export default function invoiceReducer(state = initialState, action) {
  switch (action.type) {
    case SET_INVOICE_SEND_DATA:
      return {
        ...state,
        invoiceSendData: action.payload
      };
    case SET_PROCESSOR_TYPE:
      return {
        ...state,
        processorType: action.payload,
      };
    default:
      return state;
  }
}
